import { useCallback } from 'react';
import { IdentificationFormStepNames } from '../types';
import store from '~/store/store';
import { TOwnershipStructure } from '../forms/OwnershipStructure/types';
import { TGeneralInfoLegalResident } from '../forms/GeneralInfo/types';

export const useGetIsStepDisabled = () => {
  return useCallback((name?: string) => {
    const isBeneficiariesAbsent = (
      store.getState().identification.formData.ownershipStructure as TOwnershipStructure
    )?.isBeneficiariesAbsent;

    const { isOtherTaxResident, isControllingPersonTaxResidentOtherJurisdiction } =
      (store.getState().identification.formData.generalInfo as TGeneralInfoLegalResident) || {};
    const needsTaxResidencyStep =
      isOtherTaxResident || isControllingPersonTaxResidentOtherJurisdiction;
    return (
      (name === IdentificationFormStepNames.additionalInformation && isBeneficiariesAbsent) ||
      (name === IdentificationFormStepNames.taxResidencyAdditionalInformation &&
        !needsTaxResidencyStep)
    );
  }, []);
};
